import React from 'react';
import {compose, graphql} from 'react-apollo';
import {Elements, injectStripe, CardElement} from 'react-stripe-elements';
import {Button, Card, Input, Label, Loading} from 'ui-kit';
import gql from 'graphql-tag';

import * as styles from './BillingInfo.module.css';

class BillingInfo extends React.Component {
  state = {
    formVisible: false,
    status: null, // loading | null
    cardholderName: '',
  };

  render() {
    const {billingSource} = this.props;
    const {formVisible, status, cardholderName} = this.state;

    let content;
    if (formVisible) {
      content = (
        <div>
          <p>
            <strong>Connect billing source</strong> <br />
            This card will be charged $200.00 each month.
          </p>

          <Input
            label="Cardholder name"
            name="cardholderName"
            value={cardholderName}
            onChange={this.handleInputChange}
          />

          <div className={styles.CardElementContainer}>
            <Label>Card details</Label>
            <div className={styles.CardElement}>
              <CardElement
                style={{
                  base: {
                    fontWeight: 500,
                    fontSize: '16px',
                    fontSmoothing: 'antialiased',
                  },
                }}
              />
            </div>
          </div>

          <Button
            onClick={this.handleCardSubmit}
            disabled={status === 'loading'}
          >
            {status === 'loading' ? <Loading immediate /> : 'Save'}
          </Button>
        </div>
      );
    } else if (billingSource == null) {
      content = (
        <div>
          <p className={styles.EmptyStateText}>
            <strong>You do not have a billing source.</strong> <br />
            <br />
            Failure to enter a billing source before the end of your trial or
            the start of your next billing period will cause your account to be
            frozen.
          </p>
          <Button onClick={this.showForm}>Connect a billing source</Button>
        </div>
      );
    } else {
      content = (
        <div>
          <p className={styles.EmptyStateText}>
            Your current billing source is a card ending in{' '}
            <span className={styles.Last4}>{billingSource.last4}</span>
            . <br />
            <br /> You will be billed $200.00 at the start of each billing
            period.
          </p>

          <Button onClick={this.showForm} color="light">
            Change billing source
          </Button>
        </div>
      );
    }

    return <Card>{content}</Card>;
  }

  showForm = () => {
    this.setState({formVisible: true});
  };

  handleInputChange = event => {
    const {name, value} = event.target;

    this.setState({[name]: value});
  };

  handleCardSubmit = async () => {
    this.setState({status: 'loading'});

    const {stripe, mutate, onSuccess} = this.props;
    const {cardholderName} = this.state;

    const {token, error} = await stripe.createToken({
      type: 'card',
      name: cardholderName,
    });

    if (error != null) {
      this.setState({status: null});
      return;
    }

    const {id} = token;

    try {
      await mutate({variables: {input: {stripePaymentToken: id}}});

      onSuccess();
    } catch (error) {
      // TODO: Handle error
    }
  };
}

const ComposedBillingInfo = compose(
  graphql(
    gql`
      mutation CreateBillingSource($input: UpdatePracticeBillingSourceInput!) {
        updatePracticeBillingSource(input: $input) {
          errors {
            path
            message
          }
          practice {
            id
          }
        }
      }
    `,
  ),
  injectStripe,
)(BillingInfo);

export default function WrappedBillingInfo(props) {
  return (
    <Elements>
      <ComposedBillingInfo {...props} />
    </Elements>
  );
}
